import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { PEER_LANGUAGE_CODES } from './preferences';

const peerLangI18nKey = code => `CUSTOM.TRANSLATION.PEER_LANG_OPTIONS.${code}`;

export const usePeerLanguageOptions = () => {
  const { t } = useI18n();

  const options = computed(() =>
    PEER_LANGUAGE_CODES.map(value => ({
      value,
      label: t(peerLangI18nKey(value)),
    }))
  );

  const labelFor = code => t(peerLangI18nKey(code));

  return { options, labelFor };
};
